import React from "react";
import {Spinner} from "@amzn/alchemy-components-react";

export const InplaceSpinner = () =>  {
    return (
        <>
            <Spinner
                className="center-spinner"
                id="fallback-spinner"
                label="Loading..."
                size="3"
            />
        </>
    )
}